import { render } from "./RepLabStatus.vue?vue&type=template&id=44be2c33"
import script from "./RepLabStatus.vue?vue&type=script&lang=js"
export * from "./RepLabStatus.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\mlab\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__